module Omni.ResortMap {
    ngModule.directive('sidebar', ([
        function () {
            return {
                restrict: 'C',
                link: function (scope, element, attrs) {
                    var body: any = element.find(".body");
                    if (body.height > 290) {
                        body.css({ overflowY: "scroll" });
                    }
                }
            };
        }]) as any);
}
